var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.5C0 4.77614 0.223858 5 0.5 5H3.5C3.77614 5 4 4.77614 4 4.5V0.5C4 0.223858 3.77614 0 3.5 0L0.5 0C0.223858 0 0 0.223858 0 0.5L0 4.5ZM0 8.5C0 8.77614 0.223858 9 0.5 9H3.5C3.77614 9 4 8.77614 4 8.5V6.5C4 6.22386 3.77614 6 3.5 6H0.5C0.223858 6 0 6.22386 0 6.5L0 8.5ZM5 8.5C5 8.77614 5.22386 9 5.5 9H8.5C8.77614 9 9 8.77614 9 8.5V4.5C9 4.22386 8.77614 4 8.5 4H5.5C5.22386 4 5 4.22386 5 4.5V8.5ZM5.5 0C5.22386 0 5 0.223858 5 0.5V2.5C5 2.77614 5.22386 3 5.5 3H8.5C8.77614 3 9 2.77614 9 2.5V0.5C9 0.223858 8.77614 0 8.5 0L5.5 0Z",
    fill: "#43BB4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.29cb9ea164e9f9da5ba645ba5b9077e5.svg";
export { ForwardRef as ReactComponent };